// Kerrscreen Production App Index
// Routes to the appropriate Kerrscreen page based on the URL

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import Dashboard from './Dashboard';

const KerrscreenProductionApp = () => {
  return (
    <Routes>
      {/* Main dashboard */}
      <Route
        path="/"
        element={
          <ProtectedRoute requiredPermission="kerrscreen:read">
            <Dashboard />
          </ProtectedRoute>
        }
      />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/kerrscreen-production" replace />} />
    </Routes>
  );
};

export default KerrscreenProductionApp;
